import styles from "./OverlayForNodeContent.module.css";
import { createPortal } from "react-dom";
import { useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import { Error } from "@/components/messages/error/Error";
import { Success } from "@/components/messages/success/Success";
import { DefaultLoader } from "@/components/loaders/DefaultLoader/DefaultLoader";
import { FullOverlayModalsControl } from "@/stores/FullOverlayModalsControl";
import { WaitingUtils } from "@/stores/WaitingUtils";

interface OverlayForNodeContentProps {
  children: React.ReactNode | React.ReactNode[];
  modalData: FullOverlayModalsControl;
  utilsData: WaitingUtils;
  style?: React.CSSProperties;
}

export const OverlayForNodeContent = observer(
  ({ children, modalData, utilsData, style }: OverlayForNodeContentProps) => {
    const { clearModal } = modalData;
    const { openModal } = modalData;
    const [viewContent, setViewContent] = useState(false);
    const { clear, viewResultAfterLoader, setViewResultAfterLoader } = utilsData;
    const { error, waiting, success, message } = utilsData;

    useEffect(() => {
      if (!openModal) {
        clear();
        clearModal();
        setViewContent(false);
      }
    }, [openModal]);

    const endAnimation = (e: React.AnimationEvent) => {
      if (e.animationName.includes("view")) {
        setViewContent(true);
      }
    };

    if (!openModal) return null;

    return createPortal(
      <div className={styles.dataEditWaiter}>
        <div
          onAnimationEnd={endAnimation}
          className={`${styles.bodyDataEdit} ${viewContent ? styles.view : ""}`}
          style={style}
        >
          {children}
          {viewResultAfterLoader && (
            <>
              {error && <Error isHandler={modalData?.isHide}>{error}</Error>}
              {success && <Success isHandler={modalData?.isHide}>{message}</Success>}
            </>
          )}
          {waiting && viewContent && (
            <DefaultLoader
              elementIsReady={!waiting}
              callBackEndAnimation={() => setViewResultAfterLoader(false)}
            />
          )}
        </div>
      </div>,
      document.body
    );
  }
);
